<template>
  <header
    v-if="content.image && content.title"
    class="relative mt-22.5 lg:mt-0 px-5 pt-12.5 pb-22.5 lg:px-0 lg:pt-35 lg:pb-0 transition-[margin_padding] bg-dustrose"
  >
    <ResponsiveImage
      :media="content.image"
      class="absolute w-full h-full top-0 left-0 object-cover"
      v-reveal="{ class: 'v-reveal-image' }"
    />
    <div
      class="bg-black/75 p-2.5 relative z-10 text-center w-full uppercase lg:w-250 lg:mx-auto"
      v-reveal="{ delay: 400 }"
    >
      <div class="border border-pink/40 p-5 lg:p-10 transition-[padding]">
        <h1
          class="text-dustrose font-subtitle text-5xl lg:text-7xl mb-1 max-w-150 mx-auto"
          v-reveal="{ delay: 500 }"
        >
          {{ content.title }}
        </h1>
        <p v-if="content.subtitle" class="text-pink text-sm font-title" v-reveal="{ delay: 550 }">
          {{ content.subtitle }}
        </p>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'PageHeader',
  components: { ResponsiveImage },
  props: {
    content: {
      type: Object as PropType<PageHeader>,
      required: true,
    },
  },
}
</script>
